import React from "react";

const content = {
  zh: {
    services: [
      {
        title: "线上化系统服务",
        description: (
          <>
            企业全面线上化升级，
            <br />
            从简洁清晰的公司官网到业务复杂的管理系统，
            <br />
            大幅提升转化效率并降低运营成本
          </>
        ),
        technologies: ["React", "MySQL", "Node.js", "Microsoft", "AWS", "Docker"],
      },
      {
        title: "AI 部署服务",
        description: (
          <>
            企业级 AI 模型部署方案，
            <br />
            支持定制化、本地化与云端部署，
            <br />
            实现高效、安全的 AI 落地能力
          </>
        ),
        technologies: ["LangChain", "PyTorch", "Transformers", "Haggingface", "Ollama", "Ubuntu"],
      },
    ],
    contactButton: "联系我们",
  },
  en: {
    services: [
      {
        title: "Digitalization Services",
        description: (
          <>
            Comprehensive enterprise digitalization,
            <br />
            from clean company websites to complex management systems,
            <br />
            significantly improving conversion efficiency and reducing costs
          </>
        ),
        technologies: ["React", "MySQL", "Node.js", "Microsoft", "AWS", "Docker"],
      },
      {
        title: "AI Deployment Services",
        description: (
          <>
            Enterprise-grade AI model deployment solutions,
            <br />
            supporting customized, local, and cloud deployments,
            <br />
            achieving efficient and secure AI implementation
          </>
        ),
        technologies: ["LangChain", "PyTorch", "Transformers", "Haggingface", "Ollama", "Ubuntu"],
      },
    ],
    contactButton: "Contact Us",
  },
  es: {
    services: [
      {
        title: "Servicios de Digitalización",
        description: (
          <>
            Digitalización empresarial completa,
            <br />
            desde sitios web corporativos hasta sistemas de gestión complejos,
            <br />
            mejorando significativamente la eficiencia de conversión y reduciendo costos
          </>
        ),
        technologies: ["React", "MySQL", "Node.js", "Microsoft", "AWS", "Docker"],
      },
      {
        title: "Servicios de Implementación IA",
        description: (
          <>
            Soluciones de implementación de IA a nivel empresarial,
            <br />
            soportando implementaciones personalizadas, locales y en la nube,
            <br />
            logrando implementación de IA eficiente y segura
          </>
        ),
        technologies: ["LangChain", "PyTorch", "Transformers", "Haggingface", "Ollama", "Ubuntu"],
      },
    ],
    contactButton: "Contáctanos",
  },
};

// 可复用的服务卡片组件
function ServiceCard({ title, description, technologies, contactButton }) {
  const handleContactClick = () => {
    // 跳转到 WhatsApp，西班牙国家码 +34
    window.open('https://wa.me/34625139432', '_blank');
  };

  return (
    <div className="service-block">
      <div className="service-header">
        {/* 服务名称 */}
        <div className="service-name">{title}</div>

        {/* 右侧区域 */}
        <div className="service-content">
          {/* 详情 + 按钮 */}
          <div className="service-details">
            <div className="service-text">{description}</div>
            <button className="contact-button" onClick={handleContactClick}>{contactButton}</button>
          </div>

          {/* 技术标签 */}
          <div className="tech-container">
            {technologies.map((tech, i) => (
              <span key={i} className="tech-tag">
                {tech}
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* 分隔线 */}
      <div className="divider" />
    </div>
  );
}

export default function Features({ lang }) {
  const t = content[lang];

  return (
    <div className="features-container">
      {t.services.map((service, index) => (
        <ServiceCard
          key={index}
          title={service.title}
          description={service.description}
          technologies={service.technologies}
          contactButton={t.contactButton}
        />
      ))}
    </div>
  );
}
